import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  position: relative;
  justify-content: end;
  padding-right: 1.36rem;
  align-items: center;
`

export const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  background-color: #f5f5f5;
  margin-left: 12vw;

  img {
    width: 3vw;
    margin-top: 2.5vh;
    margin-bottom: 2vh;
  }

  p {
    font-family: 'Inter', sans-serif;
    font-size: 1.3vw;
    margin-top: 3.6vh;
    margin-bottom: 4vh;
  }
`

export const CancelButton = styled.button`
  width: fit-content;
  height: 2.8rem;
  background-color: #fff;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.82rem,calc(0.82rem + 0.1vw),1.4rem);
  font-weight: 700;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  border: 1px #0090D3 solid;
  border-radius: 3vw;
  cursor: pointer;
  padding: 0 .92rem;
  `

export const SaveButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 2.8rem;
  background-color: #0090D3;
  color: #fff;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  padding: 0 .92rem;
  cursor: pointer;
  // pointer-events: none;
`

export const SaveButtonImage = styled.img`
`

export const SaveButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.82rem,calc(0.82rem + 0.1vw),1.4rem);
  font-weight: 700;
  margin-left: 0.6vw;
`

